










import vue from "vue";
import {
  LimitedModeDetails as LimitedModeDetailsInterface,
  SessionDetails,
  TerratalkLiveActionNames,
  TerratalkLiveGetterNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";
import { ROUTES } from "@tt-app/constants";

import LiveExerciseListItem from "@tt-app/components/terratalkLive/LiveExerciseListItem.vue";
import ExerciseListItem from "@tt-app/components/exercise/ExerciseListItem.vue";
import LimitedModeDetails from "@tt-app/components/terratalkLive/LimitedModeDetails.vue";
import TerratalkLiveSessionActive from "@tt-app/components/notifications/TerratalkLiveSessionActive.vue";

interface Methods {
  fetchLimitedModeDetails: () => void;
  routeToDashboard: () => void;
}

interface Computed {
  activeSessionDetails: SessionDetails;
  limitedModeDetails: LimitedModeDetailsInterface;
}

export default vue.extend<Record<any, any>, Methods, Computed, Record<any, any>>({
  name: "TerratalkLiveLobby",

  components: {
    LimitedModeDetails,
    ExerciseListItem,
    LiveExerciseListItem,
    TerratalkLiveSessionActive
  },

  created() {
    if (!this.limitedModeDetails) {
      this.routeToDashboard();
    }

    this.fetchLimitedModeDetails();
  },

  methods: {
    fetchLimitedModeDetails() {
      this.$store.dispatch(
        `${TerratalkLiveNamespace}/${TerratalkLiveActionNames.REQUEST_LIMITED_MODE_DETAILS}`
      );
    },

    routeToDashboard() {
      this.$router.push(ROUTES.HOME.PATH);
    }
  },

  computed: {
    activeSessionDetails() {
      return this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.ACTIVE_SESSION_DETAILS}`
      ];
    },

    limitedModeDetails() {
      return this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.LIMITED_MODE_DETAILS}`
      ];
    }
  },

  watch: {
    limitedModeDetails(newDetails) {
      if (!newDetails) {
        this.routeToDashboard();
      }
    }
  }
});
